import KeenSlider from 'keen-slider';

function navigation(slider) {
    let wrapper, dots, arrowLeft, arrowRight

    function markup(remove) {
        wrapperMarkup(remove)
        dotMarkup(remove)
        arrowMarkup(remove)
    }

    function removeElement(elment) {
        elment.parentNode.removeChild(elment)
    }
    function createDiv(className) {
        var div = document.createElement("div")
        var classNames = className.split(" ")
        classNames.forEach((name) => div.classList.add(name))
        return div
    }

    function arrowMarkup(remove) {
        if (remove) {
            removeElement(arrowLeft)
            removeElement(arrowRight)
            return
        }
        arrowLeft = createDiv("arrow arrow--left")
        arrowLeft.addEventListener("click", () => slider.prev())
        arrowRight = createDiv("arrow arrow--right")
        arrowRight.addEventListener("click", () => slider.next())

        wrapper.appendChild(arrowLeft)
        wrapper.appendChild(arrowRight)
    }

    function wrapperMarkup(remove) {
        if (remove) {
            var parent = wrapper.parentNode
            while (wrapper.firstChild)
                parent.insertBefore(wrapper.firstChild, wrapper)
            removeElement(wrapper)
            return
        }
        wrapper = createDiv("navigation-wrapper")
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
    }

    function dotMarkup(remove) {

        if (slider.options.dots === false) return;

        if (remove) {
            removeElement(dots)
            return
        }
        dots = createDiv("dots")
        slider.track.details.slides.forEach((_e, idx) => {
            if ((idx - slider.options.slides.perView) < -1 ) return;
            var dot = createDiv("dot")
            dot.addEventListener("click", () => slider.moveToIdx(idx))
            dots.appendChild(dot)
        })
        wrapper.appendChild(dots)
    }

    function updateClasses() {
        var slide = slider.track.details.rel
        slide === 0
            ? arrowLeft.classList.add("arrow--disabled")
            : arrowLeft.classList.remove("arrow--disabled")
        slide === slider.track.details.slides.length - 1
            ? arrowRight.classList.add("arrow--disabled")
            : arrowRight.classList.remove("arrow--disabled")

        if (slider.options.dots !== false) {
            Array.from(dots.children).forEach(function (dot, idx) {
                idx === slide
                    ? dot.classList.add("dot--active")
                    : dot.classList.remove("dot--active")
            })
        }
    }

    slider.on("created", () => {
        markup()
        updateClasses()
    })
    slider.on("optionsChanged", () => {
        console.log(2)
        markup(true)
        markup()
        updateClasses()
    })
    slider.on("slideChanged", () => {
        updateClasses()
    })
    slider.on("destroyed", () => {
        markup(true)
    })
}

/*if (document.getElementById('case-study-slider')) {
    let slider = new KeenSlider("#case-study-slider", {
        origin: "center",
        breakpoints: {
            "(min-width: 400px)": {
                slides: {perView: 2, spacing: 10},
            },
            "(min-width: 1000px)": {
                slides: {perView: 3, spacing: 50},
            },
        },
        slides: {perView: 1,},
    }, [navigation]);
}

if (document.getElementById('latest-blog-slider')) {
    let blog_slider = new KeenSlider("#latest-blog-slider", {
        origin: "center",
        breakpoints: {
            "(min-width: 400px)": {
                slides: {perView: 2, spacing: 10},
            },
            "(min-width: 1000px)": {
                slides: {perView: 3, spacing: 50},
            },
        },
        slides: {perView: 1,},
        dots: false,
    }, [navigation]);
}*/

document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById('trustpilot-slider')) {
        console.log('fads');
        let trustpilot = new KeenSlider("#trustpilot-slider", {
            breakpoints: {
                "(min-width: 560px)": {
                    slides: {perView: 2, spacing: 15},
                },
                "(min-width: 1000px)": {
                    slides: {perView: 3, spacing: 15},
                },
                "(min-width: 1300px)": {
                    slides: {perView: 4, spacing: 15},
                },
            },
            slides: {perView: 1, spacing: 5},
            dots: false,
        }, [navigation]);
    }

    if (document.getElementById('related-products')) {
        related_products();
    }
});

window.related_products = function (){
    let related_products = new KeenSlider("#related-products", {
        breakpoints: {
            "(min-width: 560px)": {
                slides: {perView: 2, spacing: 15},
            },
            "(min-width: 1000px)": {
                slides: {perView: 3, spacing: 20},
            },
            "(min-width: 1300px)": {
                slides: {perView: 4, spacing: 24},
            },
        },
        slides: {perView: 1, spacing: 5},
        dots: false,
    }, [navigation]);
}

window.cross_products = function () {

    if (document.getElementById('cross-products')) {
        let cross_products = new KeenSlider("#cross-products", {
            breakpoints: {
                "(min-width: 560px)": {
                    slides: {perView: 2, spacing: 15},
                },
            },
            slides: {perView: 1, spacing: 5},
            dots: false,
        }, [navigation]);
    }
}
